import React from "react"
import { useEffect, useCallback, useContext } from 'react'
import Dodone from 'models/dodone'
import getModelMember from 'braindamage/api/getModelMember'
import updateModelMember from 'braindamage/api/updateModelMember'
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import DodoneAbstractShow from 'app/dodones/AbstractShow'
import DodoneContext from 'app/dodones/Context'
import LoadingScreen from 'app/components/LoadingScreen'
import DodoneNotification from 'app/dodones/Notification'

export default ({ dodoneId }) => {
  // TODO: Dry with dodones/CurrentResolver.jsx
  const { isPending, data: { dodone } = {} } = useQuery({
    queryKey: ['dodone', dodoneId],
    queryFn: async () => {
      const data = await getModelMember(`/api/dodones/${dodoneId}`, Dodone);
      return data;
    }
  })

  const queryClient = useQueryClient();

  useEffect(() => {
    if(!dodone) return

    DodoneNotification.show(dodone.dodoable.name)
  }, [dodone])

  const onTick = useCallback(({ formatted }) => {
    DodoneNotification.show(formatted)
  }, [dodone])

  const updateDodone = useMutation({
    mutationFn: async (params) => {
      return updateModelMember(`/api/dodones/${dodone.id}`, Dodone, { ['dodoneAttributes']: params })
    },
    onSuccess: async (data) => {
      queryClient.invalidateQueries({ queryKey: ['dodone', dodone.id] })
      queryClient.invalidateQueries({ queryKey: ['dodone', 'current'] })
      queryClient.invalidateQueries({ queryKey: ['dodone', 'today'] })
      queryClient.setQueryData(['dodone', dodone.id], data)
      queryClient.refetchQueries(['dodone', dodone.id])
    },
    onSettled: async (data) => {
      // console.log("onSettled", data);
    },
    onError: async (data) => {
      // console.log("onError", data);
    }
  })

  const startDodone = useCallback(() => {
    updateDodone.mutate({ started_at: new Date() });
  }, []);

  const finishDodone = useCallback((params = {}) => {
    params.finished_at = new Date()
    updateDodone.mutate(params)
  }, []);

  if(isPending) return <LoadingScreen />
  if(!isPending && !dodone) return <Navigate to={ `/` } replace />;

  const dodoneContextValue = {
    dodone: dodone,
    updateDodone: updateDodone,
    startDodone: startDodone,
    finishDodone: finishDodone,
    notification: DodoneNotification,
    onTick: onTick
  }

  return <div className="p-2 m-2 fcol flex-1">
           <DodoneContext.Provider value={ dodoneContextValue }>
             <DodoneAbstractShow />
           </DodoneContext.Provider>
         </div>;
};
